export function dayBefore(date: string): Date {
  let d = new Date(date)

  return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1)
}
function padZero(number: number, digits: number): string {
  return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number
}

export function formatDate(d: Date, type = 1): string {
  // type===1 format date as YYYY-MM-DD type===2 format date as YYYY.MM.DD
  const year = d.getFullYear()
  const month = padZero(d.getMonth() + 1, 2)
  const day = padZero(d.getDate(), 2)

  return type === 1 ? `${year}-${month}-${day}` : `${year}.${month}.${day}`
}